import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private count = 0;
  private spinner$ = new BehaviorSubject<SpinnerProperty>(new SpinnerProperty());

  constructor() { }

  getSpinnerObserver(): Observable<SpinnerProperty> {
    return this.spinner$.asObservable();
  }

  requestStarted(
    spinnerImage: string = "loading.svg",
    spinnerText: string = null,
    userResponsive: boolean = false,
    userFeedbackMsg: string = "Já contactado, clique aqui!",
    time: boolean = false
  ) {
    if (++this.count === 1) {
      this.spinner$.next(
        new SpinnerProperty(true, spinnerImage, spinnerText, userResponsive, userFeedbackMsg, time)
      );
    }
  }

  requestEnded() {
    if (this.count === 0 || --this.count === 0) {
      this.spinner$.next(
      new SpinnerProperty(false)
    );
    }
  }

  resetSpinner() {
    this.count = 0;
    this.spinner$.next(
      new SpinnerProperty(false)
    );
  }
}

export class SpinnerProperty{
  constructor(
    showSpinner: boolean = false,
    spinnerImage: string = "loading.svg",
    spinnerText: string = null,
    userReactive: boolean = false,
    userFeedbackMsg: string = '',
    time: boolean = false
  ) {

    this.showSpinner = showSpinner;
    this.spinnerImage = spinnerImage;
    this.spinnerText = spinnerText;
    this.userFeedbackMsg = userFeedbackMsg;
    this.userReactive = userReactive;
    this.time = time;
  }

  showSpinner: boolean;
  spinnerImage: string;
  spinnerText: string;
  userFeedbackMsg: string;
  userReactive: boolean;
  time: boolean;
}